import "./relationshipView.scss";
import "./relationshipPopover.scss";

import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";
import { findDOMNode } from "react-dom";
import ImmutablePropTypes from "react-immutable-proptypes";

import { withScrollPositionContext } from "../../components/scrollable/ScrollPositionContext";
import { immutableRecords, PropTypeShapes } from "../../types";
import { startsWithVowel } from "../../utils/stringUtils";
import RelationshipRowColumnView from "./RelationshipRowColumnView";

// import debugUtils from "../../utils/debugUtils";

class RelationshipColumnCanvasView extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this._node = findDOMNode(this);
  }

  // componentWillReceiveProps(nextProps) {
  //   debugUtils.logPropChanges("RelationshipColumnCanvasView", this.props, nextProps, true);
  // }

  getVisibleRows(rows) {
    const scrollTop = this.props.yScrollPosition.viewport.min;
    const scrollBottom = this.props.yScrollPosition.viewport.max;

    const visible = rows.filter(e => {
      return e.getIn(["rect", "bottom"]) > scrollTop && e.getIn(["rect", "top"]) < scrollBottom;
    });

    return visible;
  }

  getVisibleColumns(colGroups) {
    const scrollLeft = this.props.xScrollPosition.viewport.min;
    const scrollRight = this.props.xScrollPosition.viewport.max;

    const visible = colGroups
      .map(g => {
        return g.update("cols", cols => {
          return cols.filter(c => {
            const right = c.left + c.width;
            return right > scrollLeft && c.left < scrollRight;
          });
        });
      })
      .filter(g => g.cols.size > 0);

    return visible;
  }

  renderAddRow() {
    let addRowClasses = ["relationshipTableRow", "relationshipAddRow"];
    let addRowTop = 0;
    const minHeight =
      this.props.containerRect.height - addRowTop > 0 ? this.props.containerRect.height - addRowTop : "auto";
    const style = { minHeight: `${minHeight}px`, transform: `translateY(${addRowTop}px)` };

    return (
      <div style={style} className={addRowClasses.join(" ")}>
        <div className="rEventCol">
          <div className="relationshipAddRowPadding">&nbsp;</div>
        </div>
      </div>
    );
  }

  renderEmptyRow(noEvents, noCols, isViewFilterActive, isGlobalFilterActive) {
    let addRowClasses = ["relationshipTableRow", "relationshipEmptyRow"];
    let addRowTop = 0;
    const minHeight =
      this.props.containerRect.height - addRowTop > 0 ? this.props.containerRect.height - addRowTop : "auto";
    const style = { minHeight: `${minHeight}px`, transform: `translateY(${addRowTop}px)` };
    const isFiltered = isViewFilterActive || isGlobalFilterActive;
    let message;
    if (isFiltered) {
      message = "No items to display for this filter";
    } else {
      //#!if readonly !== true
// message = `Add ${
// noEvents
// ? `a${startsWithVowel(this.props.defaultTypeLabel) ? "n" : ""} ${this.props.defaultTypeLabel.toLowerCase()}`
// : ""
// } ${noEvents && noCols ? " and " : ""} ${noCols ? "a column" : ""} to start creating relationships.`;
      //#!else
      message = `No items to display`;
      //#!endif
    }

    return (
      <div style={style} className={addRowClasses.join(" ")}>
        <div className="rEventCol">
          <div className="relationshipEmptyRowPadding">{message}</div>
        </div>
      </div>
    );
  }

  render() {
    const data = this.props.data;
    const visible = this.getVisibleRows(data.rows);
    const visibleColumns = this.getVisibleColumns(data.colGroups);

    let emptyState;
    const noEvents = !data.rows.size;
    const noCols = !data.colGroups.find(c => c.cols.size > 1);
    if (noEvents || noCols) {
      emptyState = this.renderEmptyRow(
        noEvents,
        noCols,
        this.props.isViewFilterActive,
        this.props.isGlobalFilterActive
      );
    }

    return (
      <div onClick={this.props.onViewClick} className="relationshipColumnCanvasView">
        {emptyState ? (
          emptyState
        ) : (
          <Fragment>
            {visible.map(e => {
              const obj = e.itemDisplay.toObject();
              const rect = e.rect.merge({
                left: e.rect.left,
                right: e.rect.right,
                top: e.rect.top,
                bottom: e.rect.bottom
              });
              return (
                <RelationshipRowColumnView
                  key={obj.id}
                  rect={rect}
                  columnData={e.columnData}
                  colGroups={visibleColumns}
                  {...obj}
                  selected={this.props.selectedItemIds.indexOf(obj.id) >= 0}
                  selectedItemIds={this.props.selectedItemIds}
                  relationshipViewSettings={this.props.relationshipViewSettings}
                  onIntersectionClick={this.props.onIntersectionClick}
                  columnAgeData={e.columnAgeData}
                  viewId={this.props.viewId}
                  showEntityColor={this.props.relationshipViewSettings.showEntityColor}
                  onRowClick={this.props.onRowClick}
                />
              );
            })}
            {/* this.renderAddRow(); */}
          </Fragment>
        )}
      </div>
    );
  }
}

RelationshipColumnCanvasView.propTypes = {
  viewId: PropTypes.string.isRequired,

  data: PropTypeShapes.relationshipData.isRequired,
  sortedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  selectedItemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  allowedReferences: PropTypeShapes.allowedReferencePerSubjectObjectMap.isRequired,
  allowedInverseReferences: PropTypeShapes.allowedReferencePerSubjectObjectMap.isRequired,
  onSelectItems: PropTypes.func.isRequired,
  onAddToSelection: PropTypes.func.isRequired,
  onRemoveFromSelection: PropTypes.func.isRequired,
  onViewClick: PropTypes.func.isRequired,
  onIntersectionClick: PropTypes.func.isRequired,
  onRelationshipChange: PropTypes.func.isRequired,
  relationshipViewSettings: PropTypeShapes.relationshipViewSettings.isRequired,
  defaultTypeLabel: PropTypes.string.isRequired,
  onRowClick: PropTypes.func.isRequired,
  isGlobalFilterActive: PropTypes.bool,
  isViewFilterActive: PropTypes.bool,

  // From withScrollPositionContext
  xScrollPosition: PropTypes.instanceOf(immutableRecords.ScrollPositionRecord).isRequired,
  yScrollPosition: PropTypes.instanceOf(immutableRecords.ScrollPositionRecord).isRequired,

  // From containerContext
  containerRect: PropTypeShapes.flatRect.isRequired
};

export default withScrollPositionContext(RelationshipColumnCanvasView);
